import { cn } from '@/lib/utils'

export const acceptClassNameDelete = cn(
  'bg-red-500 border-red-600 text-white',
  'focus:border-red-500 focus:!shadow-[0_0_0_2px_rgba(255,255,255,1),0_0_0_4px_rgba(239,67,68,0.4),0_1px_2px_0_rgba(0,0,0,1)] focus:outline-none focus:outline-offset-0',
  'hover:bg-red-600 hover:border-red-700 hover:text-white'
)

export const rejectClassName = cn('hover:text-primary')
